<template>
  <div class="app__close">
    <button class="app__closeButton" @click="closeApp()">
      <svg xmlns="http://www.w3.org/2000/svg" width="35.76" height="35.759" viewBox="0 0 35.76 35.759">
        <g id="Group_65" data-name="Group 65" transform="translate(-801.118 712.73) rotate(-45)">
          <path id="Path_55" data-name="Path 55" d="M8481,968v47.571" transform="translate(-7410.548 -904)" fill="none" stroke="#000" stroke-width="3"/>
          <path id="Path_56" data-name="Path 56" d="M0,0V47.571" transform="translate(1094.237 87.785) rotate(90)" fill="none" stroke="#000" stroke-width="3"/>
        </g>
      </svg>
    </button>
  </div>
</template>

<script>
  import EventBus from "./../../event-bus";

  export default {
    methods: {
      closeApp() {
        EventBus.$emit('CLOSE_APP', false);
      }
    }
  }
</script>
